// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_pq4io_12 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._appSettingsDialogVersion_pq4io_20 {
  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
  color: var(--color-text-maxcontrast);
  margin-block-end: calc(8 * var(--default-grid-baseline));
  margin-inline: var(--form-element-label-offset);
}
._appSettingsDialogVersion__legacy_pq4io_27 {
  margin-inline: 0;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-329ac599] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-settings[data-v-329ac599] .app-settings__navigation {
  min-width: 200px;
  margin-right: calc(4 * var(--default-grid-baseline));
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.app-settings[data-v-329ac599] .app-settings__content {
  box-sizing: border-box;
  padding-inline: calc(4 * var(--default-grid-baseline));
}
.app-settings[data-v-329ac599] .app-settings__content.app-settings__non-legacy * {
  box-sizing: border-box;
}
.navigation-list[data-v-329ac599] {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: calc(3 * var(--default-grid-baseline));
}
.navigation-list__link[data-v-329ac599] {
  display: flex;
  align-content: center;
  font-size: 16px;
  height: var(--default-clickable-area);
  margin: 4px 0;
  line-height: var(--default-clickable-area);
  border-radius: var(--border-radius-element, var(--border-radius-pill));
  font-weight: bold;
  padding: 0 calc(4 * var(--default-grid-baseline));
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: transparent;
  border: none;
}
.navigation-list__link[data-v-329ac599]:hover, .navigation-list__link[data-v-329ac599]:focus {
  background-color: var(--color-background-hover);
}
.navigation-list__link--active[data-v-329ac599] {
  background-color: var(--color-primary-element-light) !important;
}
.navigation-list__link--icon[data-v-329ac599] {
  padding-inline-start: calc(2 * var(--default-grid-baseline));
  gap: var(--default-grid-baseline);
}
.navigation-list__link-icon[data-v-329ac599] {
  display: flex;
  justify-content: center;
  align-content: center;
  width: calc(var(--default-clickable-area) - 2 * var(--default-grid-baseline));
  max-width: calc(var(--default-clickable-area) - 2 * var(--default-grid-baseline));
}
@media only screen and (max-width: 512px) {
.app-settings[data-v-329ac599] .dialog__name {
    padding-inline-start: 16px;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppSettingsDialog-p8V4OFR1.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8FAA8F;EAC9F,oCAAoC;EACpC,wDAAwD;EACxD,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,sDAAsD;AACxD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,0CAA0C;EAC1C,sEAAsE;EACtE,iBAAiB;EACjB,iDAAiD;EACjD,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+DAA+D;AACjE;AACA;EACE,4DAA4D;EAC5D,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,6EAA6E;EAC7E,iFAAiF;AACnF;AACA;AACA;IACI,0BAA0B;AAC9B;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_pq4io_12 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._appSettingsDialogVersion_pq4io_20 {\n  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n  color: var(--color-text-maxcontrast);\n  margin-block-end: calc(8 * var(--default-grid-baseline));\n  margin-inline: var(--form-element-label-offset);\n}\n._appSettingsDialogVersion__legacy_pq4io_27 {\n  margin-inline: 0;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-329ac599] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-settings[data-v-329ac599] .app-settings__navigation {\n  min-width: 200px;\n  margin-right: calc(4 * var(--default-grid-baseline));\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n}\n.app-settings[data-v-329ac599] .app-settings__content {\n  box-sizing: border-box;\n  padding-inline: calc(4 * var(--default-grid-baseline));\n}\n.app-settings[data-v-329ac599] .app-settings__content.app-settings__non-legacy * {\n  box-sizing: border-box;\n}\n.navigation-list[data-v-329ac599] {\n  height: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  padding: calc(3 * var(--default-grid-baseline));\n}\n.navigation-list__link[data-v-329ac599] {\n  display: flex;\n  align-content: center;\n  font-size: 16px;\n  height: var(--default-clickable-area);\n  margin: 4px 0;\n  line-height: var(--default-clickable-area);\n  border-radius: var(--border-radius-element, var(--border-radius-pill));\n  font-weight: bold;\n  padding: 0 calc(4 * var(--default-grid-baseline));\n  cursor: pointer;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  background-color: transparent;\n  border: none;\n}\n.navigation-list__link[data-v-329ac599]:hover, .navigation-list__link[data-v-329ac599]:focus {\n  background-color: var(--color-background-hover);\n}\n.navigation-list__link--active[data-v-329ac599] {\n  background-color: var(--color-primary-element-light) !important;\n}\n.navigation-list__link--icon[data-v-329ac599] {\n  padding-inline-start: calc(2 * var(--default-grid-baseline));\n  gap: var(--default-grid-baseline);\n}\n.navigation-list__link-icon[data-v-329ac599] {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  width: calc(var(--default-clickable-area) - 2 * var(--default-grid-baseline));\n  max-width: calc(var(--default-clickable-area) - 2 * var(--default-grid-baseline));\n}\n@media only screen and (max-width: 512px) {\n.app-settings[data-v-329ac599] .dialog__name {\n    padding-inline-start: 16px;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
